import React from 'react';
import PropTypes from 'prop-types';
import { Colors } from '@common/tokens';

import ExtensionDetailItemValue from './extension-detail-item-components/extension-detail-item-value';
import ExtensionDetailItemRate from './extension-detail-item-components/extension-detail-item-rate';

export function ExtensionDetailItem({ title, children }) {
  return (
    <>
      <div className="ExtensionDetailItem">
        {title}
        <br />
        {children}
      </div>
      <style jsx>
        {`
          .ExtensionDetailItem {
            margin: 14px 0;
          }

          .ExtensionDetailItem :global(.previously) {
            font-style: italic;
            color: ${Colors.midnightLighter};
          }

          .ExtensionDetailItem :global(.pending) {
            color: ${Colors.hypnotiqRegular};
          }

          .ExtensionDetailItem :global(.active) {
            color: ${Colors.grass};
          }

          .ExtensionDetailItem :global(.retracted) {
            color: ${Colors.sunDarkest};
          }

          .ExtensionDetailItem :global(.accepted) {
            color: ${Colors.meadowDarker};
          }

          .ExtensionDetailItem :global(.rejected) {
            color: ${Colors.coral};
          }

          .ExtensionDetailItem :global(.rejected_by_approver) {
            color: ${Colors.coral};
          }
        `}
      </style>
    </>
  );
}

ExtensionDetailItem.Value = ExtensionDetailItemValue;
ExtensionDetailItem.Rate = ExtensionDetailItemRate;

ExtensionDetailItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
